var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.componentKey,
      staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container  mt-5 mb-5 pb-5 pt-4" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\r\n          Indietro\r\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12 pb-0 buyPlan center" }, [
                _c("h3", { staticClass: "center darkBlue mb-3" }),
                _vm._v(" "),
                !_vm.paySuccess
                  ? _c("div", { staticClass: "widthFull" }, [
                      _c("div", { staticClass: "row " }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-6 col-md-6 col-lg-6 text-left bgWhite"
                          },
                          [
                            _c("div", { staticClass: "row " }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-0" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.price
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.iva
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(7),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 text-right borderTopBlack"
                                },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "col-sm-0 col-md-1 col-lg-1 text-left"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-6 col-lg-4" },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "center widthFull mb-3 mt-3 bgWhite pb-3"
                              },
                              [
                                _vm._m(8),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass:
                                    "img-fluid widthFull payImage mb-2",
                                  attrs: {
                                    src: require("../../assets/images/paypal1.png")
                                  }
                                }),
                                _vm._v(" "),
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount: "" + _vm.buyPlan.amount,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount: "" + _vm.buyPlan.amount_enea,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount: "" + _vm.buyPlan.amount_dcast,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount:
                                          "" + _vm.buyPlan.amount_enea_dcast,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.autoReNew && !_vm.loadButtons
                                  ? _c("div", {
                                      attrs: { id: "paypal-button-container" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "center widthFull mb-3 mt-3 bgWhite"
                              },
                              [
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        amount: "" + _vm.buyPlan.amount,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        amount: "" + _vm.buyPlan.amount_enea,
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        amount: "" + _vm.buyPlan.amount_dcast,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        amount:
                                          "" + _vm.buyPlan.amount_enea_dcast,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.paySuccess
                  ? _c("div", { staticClass: "col-sm-12 center" }, [
                      _c("img", {
                        staticClass: "img-fluid payImage",
                        attrs: {
                          src: require("../../assets/images/success.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("h1", { staticClass: "center" }, [
                        _vm._v("Grazie per averci scelto, ")
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "center" }, [
                        _vm._v("il tuo pagamento è avvenuto con successo")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary rn-btn-dark mt-5",
                          on: {
                            click: function($event) {
                              _vm.payment = true
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "hover hover-1" }, [
                            _vm._v("Procedi")
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container  mt-5 mb-5 pb-5 pt-4" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
                  _vm._v(
                    "\r\n            Prepara e carica tutti i documenti richiesti. Al termine dell caricamento ogni singolo documento clicca su pulsante CONCLUDI.\r\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "black mt-0 text-left widthFull " },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: "star-of-life", size: "" }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v("Documenti Obbligatori")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\r\n            Indietro\r\n          ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass:
                  "pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont",
                attrs: { id: "doc-form" }
              },
              [
                _vm._l(_vm.documents[_vm.item.client_type], function(
                  doc,
                  index,
                  k
                ) {
                  return (doc.codice != "2050D11" ||
                    (_vm.item.dcast_export == "10" &&
                      doc.codice == "2050D11") ||
                    (_vm.item.to_get_cadastral_data == "0" &&
                      doc.codice == "2050D11")) &&
                    _vm.hasPrev
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-center vaillantCont pt-2 pb-2",
                          class: {
                            "pt-0": k == 0,
                            even: String(k / 2).includes(".")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-1 bordered center tablePdMob"
                            },
                            [
                              !_vm.uploadFrontPercentage[index][
                                "countImages"
                              ] ||
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "yes"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_red.png")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_yellow.png")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_green.png")
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-5 bordered text-center text-md-left"
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                                },
                                [
                                  doc.mandatory == "yes"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mandatoryDoc",
                                        attrs: {
                                          icon: "star-of-life",
                                          size: "xs"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(doc.name) +
                                      "\r\n              "
                                  ),
                                  _vm.uploadFrontPercentage[index][
                                    "hasError"
                                  ] == "yes"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "widthFull red mt-0 pt-0 docTitleMob pl-md-3"
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                Rilevata la seguente anomalia: "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.uploadFrontPercentage[index][
                                                "error"
                                              ]
                                            ) + "\r\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors.has("fileInput" + index)
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-custom" },
                                    [
                                      _vm._v(
                                        "\r\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "fileInput" + index
                                            )
                                          ) +
                                          "\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["percent"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      attrs: { id: "progFront" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar",
                                          style: {
                                            width:
                                              _vm.uploadFrontPercentage[index][
                                                "percent"
                                              ] + "%"
                                          },
                                          attrs: {
                                            id: "progress-bar-front",
                                            role: "progressbar",
                                            "aria-valuenow": "50",
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                " +
                                              _vm._s(
                                                _vm.uploadFrontPercentage[
                                                  index
                                                ]["percent"]
                                              ) +
                                              " %\r\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-2 text-right bordered  tablePdMob",
                              class: {
                                "d-none d-md-block": doc.template == "no",
                                "d-block d-md-block": doc.template == "yes"
                              }
                            },
                            [
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Modulo")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              (_vm.getProfile.tipo_azienda !=
                                "Ditta Individuale" &&
                                _vm.getProfile.tipo_azienda !=
                                  "Professionista iscritto ad albi" &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              ((_vm.getProfile.tipo_azienda ==
                                "Ditta Individuale" ||
                                _vm.getProfile.tipo_azienda ==
                                  "Professionista iscritto ad albi") &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href:
                                          "https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf",
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: " col-md-1 bordered tablePdMob",
                              class: {
                                "col-12 center": doc.template == "no",
                                "col-6": doc.template == "yes"
                              }
                            },
                            [
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.item.status == 1 &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("div", { staticClass: "front-image2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: doc.mandatory == "yes",
                                            size: 2 * 10240,
                                            ext: ["jpeg", "jpg", "png", "pdf"],
                                            mimes: [
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                              "application/pdf"
                                            ]
                                          },
                                          expression:
                                            "{required: doc.mandatory == 'yes',size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                        }
                                      ],
                                      ref: "fileInput" + index,
                                      refInFor: true,
                                      staticClass: "btn btn-primary btn-xl",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "fileInput" + index
                                        ),
                                        valid: !!_vm.invoiceFront,
                                        helper: !!_vm.invoiceFrontBucket
                                      },
                                      attrs: {
                                        type: "file",
                                        name: "fileInput" + index,
                                        id: "fileInput" + index,
                                        "data-vv-as": doc.name
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.uploadFile(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _vm._m(10, true)
                                  ])
                                : (_vm.uploadFrontPercentage[index][
                                    "completed"
                                  ] &&
                                    _vm.item.status == 1 &&
                                    _vm.item.hasErrors == "no") ||
                                  (_vm.item.status == 1 &&
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: {
                                        to: {
                                          name: "editDocument",
                                          params: {
                                            doc: doc,
                                            dbdoc:
                                              _vm.uploadFrontPercentage[index],
                                            item: _vm.item,
                                            docIndex: index
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\r\n              Modifica\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-1 bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Visualizza")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "viewer",
                                {
                                  ref: "viewer" + index,
                                  refInFor: true,
                                  staticClass: "imagesViewer clearfix widthFull"
                                },
                                [
                                  _vm._l(
                                    _vm.uploadFrontPercentage[index]["images"],
                                    function(image, key) {
                                      return [
                                        image
                                          .substring(
                                            image.lastIndexOf(".") + 1,
                                            image.length
                                          )
                                          .toLowerCase() != "pdf"
                                          ? _c("img", {
                                              key: key,
                                              staticClass: "img-fluid",
                                              attrs: { src: image }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: key,
                                                staticClass: "pdfViewer",
                                                attrs: {
                                                  href: image,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src: require("../../assets/images/pdf.png")
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 text-center bordered tablePdMob"
                            },
                            [
                              _vm._l(
                                _vm.uploadFrontPercentage[index]["images"],
                                function(img, num) {
                                  return [
                                    img
                                      .substring(
                                        img.lastIndexOf(".") + 1,
                                        img.length
                                      )
                                      .toLowerCase() != "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb",
                                            attrs: { target: "_blank" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-alt" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb relative",
                                            attrs: {
                                              href: img,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-pdf" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "littlePdf" },
                                              [_vm._v("PDF")]
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 center bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-green btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeDocumentBlock(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Concludi")]
                                  )
                                : _vm.uploadFrontPercentage[index]["completed"]
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.documents[_vm.item.client_type], function(
                  doc,
                  index,
                  k
                ) {
                  return !_vm.hasPrev
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-center vaillantCont pt-2 pb-2",
                          class: {
                            "pt-0": k == 0,
                            even: String(k / 2).includes(".")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-1 bordered center tablePdMob"
                            },
                            [
                              !_vm.uploadFrontPercentage[index][
                                "countImages"
                              ] ||
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "yes"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_red.png")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_yellow.png")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: require("../../assets/images/traficLight_green.png")
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-5 bordered text-center text-md-left"
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                                },
                                [
                                  doc.mandatory == "yes"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mandatoryDoc",
                                        attrs: {
                                          icon: "star-of-life",
                                          size: "xs"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(doc.name) +
                                      "\r\n              "
                                  ),
                                  _vm.uploadFrontPercentage[index][
                                    "hasError"
                                  ] == "yes"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "widthFull red mt-0 pt-0 docTitleMob pl-md-3"
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                Rilevata la seguente anomalia: "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.uploadFrontPercentage[index][
                                                "error"
                                              ]
                                            ) + "\r\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors.has("fileInput" + index)
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-custom" },
                                    [
                                      _vm._v(
                                        "\r\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "fileInput" + index
                                            )
                                          ) +
                                          "\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["percent"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      attrs: { id: "progFront" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar",
                                          style: {
                                            width:
                                              _vm.uploadFrontPercentage[index][
                                                "percent"
                                              ] + "%"
                                          },
                                          attrs: {
                                            id: "progress-bar-front",
                                            role: "progressbar",
                                            "aria-valuenow": "50",
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                " +
                                              _vm._s(
                                                _vm.uploadFrontPercentage[
                                                  index
                                                ]["percent"]
                                              ) +
                                              " %\r\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-2 text-right bordered  tablePdMob",
                              class: {
                                "d-none d-md-block": doc.template == "no",
                                "d-block d-md-block": doc.template == "yes"
                              }
                            },
                            [
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Modulo")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              (_vm.getProfile.tipo_azienda !=
                                "Ditta Individuale" &&
                                _vm.getProfile.tipo_azienda !=
                                  "Professionista iscritto ad albi" &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              ((_vm.getProfile.tipo_azienda ==
                                "Ditta Individuale" ||
                                _vm.getProfile.tipo_azienda ==
                                  "Professionista iscritto ad albi") &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href:
                                          "https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf",
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: " col-md-1 bordered tablePdMob",
                              class: {
                                "col-12 center": doc.template == "no",
                                "col-6": doc.template == "yes"
                              }
                            },
                            [
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.item.status == 1 &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("div", { staticClass: "front-image2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: doc.mandatory == "yes",
                                            size: 2 * 10240,
                                            ext: ["jpeg", "jpg", "png", "pdf"],
                                            mimes: [
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                              "application/pdf"
                                            ]
                                          },
                                          expression:
                                            "{required: doc.mandatory == 'yes',size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                        }
                                      ],
                                      ref: "fileInput" + index,
                                      refInFor: true,
                                      staticClass: "btn btn-primary btn-xl",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "fileInput" + index
                                        ),
                                        valid: !!_vm.invoiceFront,
                                        helper: !!_vm.invoiceFrontBucket
                                      },
                                      attrs: {
                                        type: "file",
                                        name: "fileInput" + index,
                                        id: "fileInput" + index,
                                        "data-vv-as": doc.name
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.uploadFile(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _vm._m(11, true)
                                  ])
                                : (_vm.uploadFrontPercentage[index][
                                    "completed"
                                  ] &&
                                    _vm.item.status == 1 &&
                                    _vm.item.hasErrors == "no") ||
                                  (_vm.item.status == 1 &&
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: {
                                        to: {
                                          name: "editDocument",
                                          params: {
                                            doc: doc,
                                            dbdoc:
                                              _vm.uploadFrontPercentage[index],
                                            item: _vm.item,
                                            docIndex: index
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\r\n              Modifica\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-1 bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Visualizza")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "viewer",
                                {
                                  ref: "viewer" + index,
                                  refInFor: true,
                                  staticClass: "imagesViewer clearfix widthFull"
                                },
                                [
                                  _vm._l(
                                    _vm.uploadFrontPercentage[index]["images"],
                                    function(image, key) {
                                      return [
                                        image
                                          .substring(
                                            image.lastIndexOf(".") + 1,
                                            image.length
                                          )
                                          .toLowerCase() != "pdf"
                                          ? _c("img", {
                                              key: key,
                                              staticClass: "img-fluid",
                                              attrs: { src: image }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: key,
                                                staticClass: "pdfViewer",
                                                attrs: {
                                                  href: image,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src: require("../../assets/images/pdf.png")
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 text-center bordered tablePdMob"
                            },
                            [
                              _vm._l(
                                _vm.uploadFrontPercentage[index]["images"],
                                function(img, num) {
                                  return [
                                    img
                                      .substring(
                                        img.lastIndexOf(".") + 1,
                                        img.length
                                      )
                                      .toLowerCase() != "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb",
                                            attrs: { target: "_blank" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-alt" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb relative",
                                            attrs: { target: "_blank" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-pdf" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "littlePdf" },
                                              [_vm._v("PDF")]
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 center bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-green btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeDocumentBlock(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Concludi")]
                                  )
                                : _vm.uploadFrontPercentage[index]["completed"]
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.item.aditional_enea_data == null &&
                _vm.item.enea_request == "1" &&
                2 == 3
                  ? _c("div", { staticClass: "col-md-12 center mb-4" }, [
                      _c(
                        "h5",
                        { staticClass: "Regular text-center h0 widthFull " },
                        [
                          _vm.concluded
                            ? _c("b", [
                                _c("span", { staticClass: "yellow" }, [
                                  _vm._v("Attenzione!")
                                ]),
                                _vm._v(
                                  " Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni "
                                )
                              ])
                            : _c("b", [
                                _c("span", { staticClass: "yellow" }, [
                                  _vm._v("Attenzione!")
                                ]),
                                _vm._v(
                                  "  Per redigere ed inviare la pratica ENEA avremo bisogno di ulteriori informazioni che ti chiederemo alla conclusione del Set Documentale. "
                                )
                              ]),
                          _vm._v(" "),
                          _vm.concluded
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary m-2 btn-sm",
                                  attrs: {
                                    to: {
                                      name: "complateEneaData",
                                      params: { item: _vm.item }
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\r\n              Inserisci\r\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.status == 1
                  ? _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-12 text-right" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.sendPracticeToKPMG()
                                }
                              }
                            },
                            [_vm._v("Procedi")]
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
      _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
        _c("b", [
          _vm._v(
            " Per completare la tua pratica, paga il servizio con una Carta o PayPal "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
        _vm._v(
          "\r\n          Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.\r\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v("  Prezzo Servizio/Pratica (IVA Esclusa)  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v("  IVA 22%  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(
          "Prezzo  Servizio di redazione e invio pratica ENEA (IVA Esclusa)  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v("  IVA 22%  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v('  Prezzo Servizio "Visura Catastale" (IVA Esclusa)  ')
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v("  IVA 22%  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 borderTopBlack text-left" }, [
      _c("h5", { staticClass: " text-right mb-4" }, [
        _vm._v(
          "\r\n                    TOTALE (IVA inclusa)\r\n                  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center  mb-3 mt-0 pt-3" }, [
      _c("b", [_vm._v("Paga con")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
      _c("b", [_vm._v(" Gestione Documenti ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel2 labelFileInput",
        attrs: { for: "invoiceFront" }
      },
      [_c("span", { staticClass: "smallText center white" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel2 labelFileInput",
        attrs: { for: "invoiceFront" }
      },
      [_c("span", { staticClass: "smallText center white" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38471c95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38471c95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/index.vue
// module id = null
// module chunks = 